import { render, staticRenderFns } from "./StudentListTable.vue?vue&type=template&id=21409005&scoped=true&lang=pug&"
import script from "./StudentListTable.vue?vue&type=script&lang=ts&"
export * from "./StudentListTable.vue?vue&type=script&lang=ts&"
import style0 from "./StudentListTable.vue?vue&type=style&index=0&id=21409005&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21409005",
  null
  
)

export default component.exports